import React from 'react';

import SectionHeader from './SectionHeader';
import SectionAbout from './SectionAbout';
import SectionTransformation from './SectionTransformation';
import SectionTestimonials from './SectionTestimonials';
import SectionPrinciples from './SectionPrinciples';
import SectionFooter from 'views/SectionFooter';

const Landing = () => {
  return (
    <>
      <SectionHeader />
      <SectionAbout />
      <SectionTransformation />
      <SectionTestimonials />
      <SectionPrinciples />
      <SectionFooter />
    </>
  );
};

export default Landing;
